<!-- Carregando: altura preservada para o layout nao pular quando o grafico entra -->
<div class="dashboard-grafico__skeleton" *ngIf="loading">
  <p-skeleton height="220px" borderRadius="12px"></p-skeleton>
</div>

<ng-container *ngIf="!loading">
  <!-- Serie com 2+ meses: grafico de BARRAS (nunca composicao) -->
  <div class="dashboard-grafico__canvas" *ngIf="temGrafico" role="img" [attr.aria-label]="ariaLabel">
    <p-chart type="bar" [data]="chartData" [options]="chartOptions" height="220px"></p-chart>
  </div>

  <!-- Serie de um mes so: dois pontos nao desenham tendencia, entao vira frase -->
  <p class="dashboard-grafico__fallback" *ngIf="temSerieCurta">
    {{ textoSerieCurta }}
  </p>

  <!-- Periodo sem recebimento NAO e erro: e a resposta -->
  <p class="dashboard-grafico__fallback" *ngIf="estaVazio">
    {{ texts.sem_dados }}
  </p>

  <!-- Equivalente textual do grafico, para leitor de tela -->
  <table class="dashboard-grafico__resumo" *ngIf="temGrafico">
    <caption>{{ texts.titulo }}</caption>
    <tbody>
      <tr *ngFor="let item of dados">
        <th scope="row">{{ item.rotulo }}</th>
        <td>{{ formatarValor(item.valor) }}</td>
        <td>{{ item.quantidade }} {{ texts.pagamentos }}</td>
      </tr>
    </tbody>
  </table>
</ng-container>
